export default "__VITE_ASSET__DPL$bjMM__"